module.exports = __webpack_public_path__ + "img/D.Toth-Kriszta-home.41a2eecb.png";